import * as yup from 'yup'

export const FundTransferFormValidationSchema = yup.object().shape({
    capturedPaymentReference: yup.string().max(100).required(),
})
